import HeadingGoes from "./HeadingGoes";

export default HeadingGoes;
